import { redirectIfAuthenticated } from '@/utils/routes';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public')({
  component: PathlessLayoutComponent,
  beforeLoad: redirectIfAuthenticated,
});

function PathlessLayoutComponent() {
  return <Outlet />;
}
